module.exports = __webpack_public_path__ + "static/media/dashboard-logo.eb402e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-logo.svg
// module id = 175
// module chunks = 1